import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { DirectionalCell } from '../../models/directional-cell.model';
import { MiscUtil } from 'src/shared/utilities/misc.util';

@Component({
    selector: 'smt-staffing-grid-value',
    templateUrl: './staffing-grid-value.component.html',
    styleUrls: ['./staffing-grid-value.component.scss']
})
export class StaffingGridValueComponent implements OnInit {
    @Input() gridCell: DirectionalCell;
    @Input() type: string;
    @Input() maxValue: number;
    @Input() minValue: number;
    @Input() required: boolean;
    @Input() readOnly: boolean;
    @Input() allowedDecimalPlaces: number = 2;
    @Input() isAddOn: boolean = false;

    @Output() keyPressed = new EventEmitter<any>();

    @Output() focusOut = new EventEmitter<any>();

    inputKey : string;

    private readonly defaultMaxInput = 9999;
    private readonly defaultMinInput = 0;

    constructor(private _costCenterConfigurationService: CostCenterConfigurationService) { }

    ngOnInit() {
        this.setInputMaximum();
        this.setInputMinimum();
    }

    private getCellElement(cellId: string): HTMLInputElement {
        return (document.getElementById(cellId)) as HTMLInputElement;
    }

    get isRequired() {
        return this.required && !MiscUtil.isValidNumber(this.gridCell.value);
    }

    moveCell(moveToCellId: string) {
        let element = this.getCellElement(moveToCellId);

        if (element) {
            element.focus();
        }
    }

    onCellKeyDown(event: any) {
        const keyDown = "arrowdown";
        const keyLeft = "arrowleft";
        const keyRight = "arrowright";
        const keyUp = "arrowup";
        const keyEnter = "enter";

        let keyPressed = (event.key as string).toLowerCase();
        this.inputKey = keyPressed;

        // Only care about arrow key presses.  All others can be ignored.
        if (keyPressed != keyDown &&
            keyPressed != keyLeft &&
            keyPressed != keyRight &&
            keyPressed != keyUp &&
            keyPressed != keyEnter) {
            return;
        }

        let moveCellId: string;

        switch (keyPressed) {
            case keyDown:
            case keyEnter:
                moveCellId = this.gridCell.belowCellId;
                break;
            case keyLeft:
                moveCellId = this.gridCell.leftCellId;
                break;
            case keyRight:
                moveCellId = this.gridCell.rightCellId;
                break;
            case keyUp:
                moveCellId = this.gridCell.aboveCellId;
                break;
        }

        moveCellId = moveCellId ? moveCellId : this.gridCell.id;

        this.moveCell(moveCellId);
        // If we make it this far then the key pressed was handled and no futher action is required.
        // This stops the default behavior of that key press from happening.
        event.preventDefault();
    }

    onCellKeyUp(value: number) {
        
        if (!this.isAddOn || (this.inputKey != '-' && this.isAddOn)) {
            if (MiscUtil.isValidNumber(value)) {
                value = Math.min(value, this.maxValue);
                value = Math.max(value, this.minValue);

                if (value !== 0) {
                    value = +value.toFixed(this.allowedDecimalPlaces);
                }

                this._costCenterConfigurationService.announceFormIsDirty(true);
            }

            this.gridCell.value = value;

            let element = this.getCellElement(this.gridCell.id);

            if (element && element.value && element.value != value.toString()) {
                element.value = value.toString();
            }

            this.keyPressed.emit(this.gridCell);
        }
    }

    setInputMaximum() {
        if (!MiscUtil.isValidNumber(this.maxValue)) {
            this.maxValue = this.defaultMaxInput;
        }
    }

    setInputMinimum() {
        if (!MiscUtil.isValidNumber(this.minValue)) {
            this.minValue = this.defaultMinInput;
        }
    }
    onFocusOut(value: number){
        this.focusOut.emit(this.gridCell);
    }
}